import React, { useState, useLayoutEffect, useRef } from "react";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import AddIcon from "@mui/icons-material/Add";

// import JS files

import PanelTemplate from "../../../shares/PanelTemplate";
import MuiButton from "../../../shares/MuiButton";
import PanelFilter from "../../../shares/PanelFilter";
import MuiPagination from "../../../shares/MuiPagination";
import { fixNumbers } from "../../../../utils";
import useFetch from "../../../../context/useFetch";
import AddEmployee from "./AddEmployee";
import EmployeeCard from "./EmployeeCard";
import { useUserData } from "../../../../context/UserDataContext";

// import Others files

const Employee = (props) => {
  const [openAddCustomerModal, setOpenAddCustomerModal] = useState(false);
  const handleModal = () => {
    setOpenAddCustomerModal((before) => !before);
  };
  const [nameFilter, setNameFilter] = useState(null);
  const [storeFilter, setStoreFilter] = useState(null);
  const [phoneFilter, setPhoneFilter] = useState(null);

  const [isFilterOn, setIsFilterOn] = useState(false);

  const filterList = [
    {
      type: "textField",
      label_fa: "نام و نام خانوادگی",
      label_en: "fullName",
      state: nameFilter,
    },
    {
      type: "textField",
      label_fa: "همراه",
      label_en: "phone",
      state: phoneFilter,
      isLTR: true,
    },
  ];

  const {
    formState: { errors },
  } = useForm();

  const [pageData, setPageData] = useState({ results: [] });

  const [paginationPageInfo, setPaginationPageInfo] = useState({
    current: 1,
    pageSize: 30,
  });

  const { userData } = useUserData();

  const getCustomer = useFetch({
    method: "get",
    url: `User_Service/${userData.username}/get_employee`,
    params: {
      name: nameFilter,
      store: storeFilter,
      phone: fixNumbers(phoneFilter),
    },
    pagination: paginationPageInfo,
    trigger: true,
    setter: setPageData,
    argFunc: (res) => {
      setPaginationPageInfo({
        current: res.current,
        pageSize: res.pageSize,
        count: res.count,
        next: res.next,
        previous: res.previous,
      });
    },
    errMessage: (mess) => {
      toast.error("خطا در برقراری ارتباط با سرور", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });

  const update_filter = (state, e) => {
    if (state == "fullName") setNameFilter(e.length > 0 ? e : null);
    if (state == "store") setStoreFilter(e.length > 0 ? e : null);
    if (state == "phone") setPhoneFilter(e.length > 0 ? e : null);
  };
  const filter = () => {
    if (nameFilter !== null || storeFilter !== null || phoneFilter !== null) {
      setIsFilterOn(true);
      getCustomer.reFetch();
    }
  };

  const reset_filter = () => {
    setNameFilter(null);
    setStoreFilter(null);
    setPhoneFilter(null);
    getCustomer.reFetch();
  };

  const onChangePage = (e, page) => {
    setPaginationPageInfo({
      ...paginationPageInfo,
      current: page,
    });
    // setPageData({ results: [] });
    getCustomer.reFetch();
  };
  return (
    <>
      <PanelTemplate sidebarActiveLink="employee">
        <>
          <div className="panel-main-header">
            <span className="">مدیریت کارمندان </span>
          </div>
          <div className="add-item-container">
            <span className="text">
              برای اضافه کردن کارمند جدید روی دکمه افزودن کلیک کنید.
            </span>
            <MuiButton
              onClick={handleModal}
              variant="outlined"
              icon={<AddIcon />}
              color="secondary"
              text="افزودن"
            />
          </div>
          {openAddCustomerModal && (
            <AddEmployee
              openModal={openAddCustomerModal}
              setOpenModal={setOpenAddCustomerModal}
              getFunc={getCustomer}
            />
          )}

          <PanelFilter
            header="فیلتر کارمند ها:"
            list={filterList}
            update_filter={update_filter}
            filter={filter}
            reset_filter={reset_filter}
          />
          <div className="grid md:grid-cols-4 md:gap-x-6 gap-y-4 md:gap-y-6">
            {pageData.results.map((item, index) => {
              return [
                <>
                  <EmployeeCard
                    key={item.id}
                    name={item.name}
                    address={item.address}
                    city={item.city}
                    email={item.email}
                    phone={item.phone}
                    phone_number={item.phone_number}
                    store_name={item.store_name}
                    attach_file={item.attach_file}
                    userId={item.id}
                    user={item.user}
                    getFunc={getCustomer}
                  />
                </>,
              ];
            })}
          </div>
          <MuiPagination
            onChange={onChangePage}
            count={Math.ceil(
              paginationPageInfo.count / paginationPageInfo.pageSize
            )}
          />
        </>
      </PanelTemplate>
    </>
  );
};

export default Employee;
